import * as ListingInquiry from './listing-inquiry/schemas'
import * as MultipostInquiry from './multipost-inquiry/schemas'
import * as RentalInquiry from './rental-inquiry/schemas'

export { ListingInquiry, MultipostInquiry, RentalInquiry }
